import _ from "lodash";
import ACLStore from "lib/aclStore";

import {
  ENABLE_SHAREPOINT_PICKER_STAFF,
  ENABLE_SHAREPOINT_PICKER_STUDENT,
  ENABLE_SHAREPOINT_PICKER_V2_STAFF,
  ENABLE_SHAREPOINT_FOR_SUBMISSION_TEMPLATES,
} from "Constants/permissionConstants";

const enableSharepointPickerV1ForUser = userType => {
  switch (userType) {
    case "staff": {
      return ACLStore.can(ENABLE_SHAREPOINT_PICKER_STAFF);
    }
    case "student": {
      return ACLStore.can(ENABLE_SHAREPOINT_PICKER_STUDENT);
    }
    default:
      return false;
  }
};

export const enableSharepointPickerV2ForUser = userType => {
  switch (userType) {
    case "staff": {
      return ACLStore.can(ENABLE_SHAREPOINT_PICKER_V2_STAFF);
    }
    case "student": {
      return ACLStore.can(ENABLE_SHAREPOINT_PICKER_STUDENT);
    }
    default:
      return false;
  }
};

const enableSharepointSupportInSubmissionTemplates = userType => {
  if (_.isEqual(userType, "staff")) {
    return (
      enableSharepointPickerV2ForUser(userType) &&
      ACLStore.can(ENABLE_SHAREPOINT_FOR_SUBMISSION_TEMPLATES)
    );
  }
  return false;
};

export const enableSharepointPickerForUser = ({ userType, sourceType }) => {
  if (
    _.includes(
      ["STUDENT_TEMPLATE", "PROJECT_GROUP_REPORT_TEMPLATE"],
      sourceType
    )
  ) {
    return enableSharepointSupportInSubmissionTemplates(userType);
  }
  return (
    enableSharepointPickerV1ForUser(userType) ||
    enableSharepointPickerV2ForUser(userType)
  );
};

export const constructPath = (...paths) => {
  return paths
    .map(path => path.replace(/^[\\|/]/, "").replace(/[\\|/]$/, ""))
    .join("/")
    .replace(/\\/g, "/");
};
